import SectionWrapper from '@/home/common/SectionWrapper';
import LoadingVehicleCarousel from '@/home/common/VehicleCarousel/LoadingVehicleCarousel';
import useGetCarouselVehicles from './hooks/useGetCarouselVehicles';
import useGetMostViewedOrMostRecentYMM from './hooks/useGetMostViewedOrMostRecentYMM';
import RecCarousel from './RecCarousel';

enum CarouselType {
  BecauseYouViewed = 'Because you viewed',
  FreeShipping = 'Vehicles with free shipping',
  UpYourRide = 'Upgrade your ride',
  BudgetFriendly = 'Budget friendly options',
  PriceDrops = 'Recent price drops'
}

export default function RecommendedCarousels() {
  const targetVehicle = useGetMostViewedOrMostRecentYMM();
  const {
    carouselVehicles: {
      becauseYouViewed,
      freeShipping,
      upYourRide,
      budgetFriendly,
      priceDrops
    },
    showCarousel
  } = useGetCarouselVehicles();

  return showCarousel ? (
    <>
      {becauseYouViewed.length > 0 && targetVehicle && (
        <RecCarousel
          title={`${CarouselType.BecauseYouViewed} ${targetVehicle.make} ${targetVehicle.model}`}
          vehicles={becauseYouViewed}
          analyticSection={CarouselType.BecauseYouViewed}
        />
      )}
      {freeShipping.length > 0 && (
        <RecCarousel
          title={CarouselType.FreeShipping}
          vehicles={freeShipping}
          analyticSection={CarouselType.FreeShipping}
        />
      )}
      {upYourRide.length > 0 && (
        <RecCarousel
          title={CarouselType.UpYourRide}
          vehicles={upYourRide}
          analyticSection={CarouselType.UpYourRide}
        />
      )}
      {budgetFriendly.length > 0 && (
        <RecCarousel
          title={CarouselType.BudgetFriendly}
          vehicles={budgetFriendly}
          analyticSection={CarouselType.BudgetFriendly}
        />
      )}
      {priceDrops.length > 0 && (
        <RecCarousel
          title={CarouselType.PriceDrops}
          vehicles={priceDrops}
          analyticSection={CarouselType.PriceDrops}
          showBorder={false}
        />
      )}
    </>
  ) : (
    <SectionWrapper analyticsSection={'rec-carousels-loading'}>
      <LoadingVehicleCarousel hasBottomBorder />
      <LoadingVehicleCarousel hasBottomBorder />
      <LoadingVehicleCarousel hasBottomBorder />
      <LoadingVehicleCarousel hasBottomBorder />
      <LoadingVehicleCarousel />
    </SectionWrapper>
  );
}
